@if (!drawerMode) {
  <app-page-breadcrumb [pageTitle]="pageTitle"></app-page-breadcrumb>
}

<ng-container
  *ngIf="drawerMode; then formBody; else pageWrapper"
></ng-container>

<ng-template #pageWrapper>
  <div class="grid grid-cols-1 gap-6">
    <app-component-card
      [title]="pageTitle"
      desc="Complete los datos de la categoría"
    >
      <ng-container *ngTemplateOutlet="formBody"></ng-container>
    </app-component-card>
  </div>
</ng-template>

<ng-template #formBody>
  <div [class.p-6]="drawerMode">
    <!-- Loading -->
    @if (loading) {
      <div class="flex justify-center items-center py-12">
        <div
          class="animate-spin rounded-full h-8 w-8 border-b-2 border-brand-500"
        ></div>
        <span class="ml-3 text-gray-500 dark:text-gray-400"
          >Cargando datos...</span
        >
      </div>
    }

    <!-- Error -->
    @if (error) {
      <div
        class="mb-4 p-4 bg-error-50 border border-error-200 rounded-lg dark:bg-error-500/10 dark:border-error-500/20"
      >
        <div class="flex items-center gap-3">
          <svg
            class="w-5 h-5 text-error-500"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
            ></path>
          </svg>
          <p class="text-error-600 dark:text-error-400">{{ error }}</p>
        </div>
      </div>
    }

    <!-- Formulario -->
    @if (!loading) {
      <form
        [formGroup]="form"
        (ngSubmit)="guardar()"
        class="space-y-5"
      >
        <!-- Nombre de la Categoría -->
        <div>
          <label
            class="mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-300"
          >
            Nombre <span class="text-error-500">*</span>
          </label>
          <input
            type="text"
            formControlName="name"
            placeholder="Nombre de la categoría"
            class="dark:bg-dark-900 h-11 w-full rounded-lg border bg-transparent px-4 py-2.5 text-sm text-gray-800 shadow-theme-xs placeholder:text-gray-400 focus:border-brand-300 focus:outline-hidden focus:ring-3 focus:ring-brand-500/10 dark:border-gray-700 dark:bg-gray-900 dark:text-white/90 dark:placeholder:text-white/30 dark:focus:border-brand-800 disabled:opacity-50 disabled:cursor-not-allowed"
            [class.border-error-500]="hasError('name')"
            [class.border-gray-300]="!hasError('name')"
          />
          @if (hasError('name')) {
            <p class="mt-1.5 text-sm text-error-500">{{ getError('name') }}</p>
          }
        </div>

        <!-- Descripcion -->
        <div>
          <label
            class="mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-300"
          >
            Descripción
          </label>
          <textarea
            formControlName="description"
            rows="3"
            placeholder="Descripción detallada de la categoría"
            class="dark:bg-dark-900 w-full rounded-lg border border-gray-300 bg-transparent px-4 py-2.5 text-sm text-gray-800 shadow-theme-xs placeholder:text-gray-400 focus:border-brand-300 focus:outline-hidden focus:ring-3 focus:ring-brand-500/10 dark:border-gray-700 dark:bg-gray-900 dark:text-white/90 dark:placeholder:text-white/30 dark:focus:border-brand-800 disabled:opacity-50 disabled:cursor-not-allowed"
          ></textarea>
          @if (hasError('description')) {
            <p class="mt-1.5 text-sm text-error-500">
              {{ getError('description') }}
            </p>
          }
        </div>

        <!-- Tipo -->
        <div>
          <label
            class="mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-300"
          >
            Tipo <span class="text-error-500">*</span>
          </label>
          <select
            formControlName="type"
            class="dark:bg-dark-900 h-11 w-full rounded-lg border bg-transparent px-4 py-2.5 text-sm text-gray-800 shadow-theme-xs focus:border-brand-300 focus:outline-hidden focus:ring-3 focus:ring-brand-500/10 dark:border-gray-700 dark:bg-gray-900 dark:text-white/90 dark:focus:border-brand-800 disabled:opacity-50 disabled:cursor-not-allowed"
            [class.border-error-500]="hasError('type')"
            [class.border-gray-300]="!hasError('type')"
          >
            <option value="product">Producto</option>
            <option value="service">Servicio</option>
            <option value="both">Ambos</option>
          </select>
          @if (hasError('type')) {
            <p class="mt-1.5 text-sm text-error-500">{{ getError('type') }}</p>
          }
        </div>

        <!-- Icono y Orden en 2 columnas -->
        <div class="grid grid-cols-1 gap-5 sm:grid-cols-2">
          <!-- Icono -->
          <div>
            <label
              class="mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-300"
            >
              Icono
            </label>
            <input
              type="text"
              formControlName="icon"
              placeholder="software-icon"
              class="dark:bg-dark-900 h-11 w-full rounded-lg border border-gray-300 bg-transparent px-4 py-2.5 text-sm text-gray-800 shadow-theme-xs placeholder:text-gray-400 focus:border-brand-300 focus:outline-hidden focus:ring-3 focus:ring-brand-500/10 dark:border-gray-700 dark:bg-gray-900 dark:text-white/90 dark:placeholder:text-white/30 dark:focus:border-brand-800 disabled:opacity-50 disabled:cursor-not-allowed"
            />
            @if (hasError('icon')) {
              <p class="mt-1.5 text-sm text-error-500">
                {{ getError('icon') }}
              </p>
            }
            <p class="mt-1 text-xs text-gray-500 dark:text-gray-400">
              Identificador del icono de la categoría
            </p>
          </div>

          <!-- Orden -->
          <div>
            <label
              class="mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-300"
            >
              Orden <span class="text-error-500">*</span>
            </label>
            <input
              type="number"
              formControlName="order"
              min="1"
              step="1"
              placeholder="1"
              class="dark:bg-dark-900 h-11 w-full rounded-lg border bg-transparent px-4 py-2.5 text-sm text-gray-800 shadow-theme-xs placeholder:text-gray-400 focus:border-brand-300 focus:outline-hidden focus:ring-3 focus:ring-brand-500/10 dark:border-gray-700 dark:bg-gray-900 dark:text-white/90 dark:placeholder:text-white/30 dark:focus:border-brand-800 disabled:opacity-50 disabled:cursor-not-allowed"
              [class.border-error-500]="hasError('order')"
              [class.border-gray-300]="!hasError('order')"
            />
            @if (hasError('order')) {
              <p class="mt-1.5 text-sm text-error-500">
                {{ getError('order') }}
              </p>
            }
            <p class="mt-1 text-xs text-gray-500 dark:text-gray-400">
              Orden de visualización dentro del mismo nivel
            </p>
          </div>
        </div>

        <!-- Padre y Estado en 2 columnas -->
        <div class="grid grid-cols-1 gap-5 sm:grid-cols-2">
          <!-- Padre -->
          <div>
            <label
              class="mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-300"
            >
              Categoría Padre
            </label>
            <select
              formControlName="idParent"
              class="dark:bg-dark-900 h-11 w-full rounded-lg border border-gray-300 bg-transparent px-4 py-2.5 text-sm text-gray-800 shadow-theme-xs focus:border-brand-300 focus:outline-hidden focus:ring-3 focus:ring-brand-500/10 dark:border-gray-700 dark:bg-gray-900 dark:text-white/90 dark:focus:border-brand-800"
            >
              <option [ngValue]="null">
                🌳 Sin padre — será categoría raíz (Nivel 1)
              </option>
              @for (cat of categoriasForParentSelect; track cat.id) {
                <option
                  [ngValue]="cat.id"
                  [disabled]="cat._disabled"
                  [title]="
                    cat._disabled
                      ? 'Esta categoría ya está en el nivel máximo (' +
                        MAX_DEPTH +
                        '), no puede tener subcategorías'
                      : 'Crear como subcategoría de ' + cat.name
                  "
                >
                  {{ cat._label }}
                </option>
              }
            </select>

            <!-- Hint dinámico según si hay categorías disponibles -->
            @if (loadingCategorias) {
              <p class="mt-1 text-xs text-gray-400 dark:text-gray-500">
                Cargando categorías...
              </p>
            } @else if (categoriasForParentSelect.length === 0) {
              <p class="mt-1 text-xs text-gray-500 dark:text-gray-400">
                No hay otras categorías. Esta será una categoría raíz.
              </p>
            } @else if (!haySeleccionablesComoPadre) {
              <p class="mt-1 text-xs text-orange-500 dark:text-orange-400">
                ⚠ Todas las categorías están en el nivel máximo ({{
                  MAX_DEPTH
                }}). Solo puedes crear categorías raíz.
              </p>
            } @else {
              <p class="mt-1 text-xs text-gray-500 dark:text-gray-400">
                📁 con subcategorías · 📄 sin subcategorías · las opciones en
                gris ya alcanzaron el nivel máximo ({{ MAX_DEPTH }}).
              </p>
            }
          </div>

          <!-- Estado -->
          <div class="flex items-start gap-3 pt-2 sm:pt-7">
            <input
              type="checkbox"
              formControlName="isActive"
              id="isActive"
              class="mt-0.5 h-4 w-4 rounded border-gray-300 text-brand-500 focus:ring-brand-500/10 dark:border-gray-600 dark:bg-gray-800"
            />
            <div>
              <label
                for="isActive"
                class="text-sm font-medium text-gray-700 dark:text-gray-300"
              >
                Categoría activa
              </label>
              <p class="text-xs text-gray-500 dark:text-gray-400">
                Si está desmarcado, la categoría no estará disponible
              </p>
            </div>
          </div>
        </div>

        <!-- Botones de accion -->
        <div
          class="flex items-center justify-end gap-3 pt-4 border-t border-gray-200 dark:border-gray-700"
        >
          <app-button
            variant="outline"
            type="button"
            (btnClick)="cancelar()"
          >
            Cancelar
          </app-button>
          <app-button
            variant="primary"
            type="button"
            (btnClick)="guardar()"
            [disabled]="saving || form.invalid"
          >
            {{
              saving
                ? 'Guardando...'
                : isEditing
                  ? 'Actualizar'
                  : 'Crear Categoría'
            }}
          </app-button>
        </div>
      </form>
    }
  </div>
</ng-template>
